(function ($) {
  $('.js-load-casinos').click(function (e) { 
    e.preventDefault();
    
    casinos($(this));
  });

  function casinos($this) {
    var list = $this.closest('.js-lsit-casinos');
    var args = $this.data('args');
    var resutls = list.find('.js-list-results');
    var loader = list.find('.js-loader');
    var loadmore = $this.parent();

    if(typeof xhr !== "undefined" && typeof xhr.abort !== "undefined") {
	    xhr.abort();
	  }

		xhr = $.ajax({
			url: vars.ajax_url,
			type: 'POST',
			dataType: 'json',
			data: {
				action: 'list_casinos',
        data: args
			},
			beforeSend: function() {
        loadmore.addClass('d-none');
        loader.removeClass('d-none');
			},
      success: function (res) {
        $this.data('args', res.args);
        resutls.append(res.html);
        loader.addClass('d-none');

        if(res.loadmore) {
					loadmore.removeClass('d-none');
        }
			}
		});
  }
})(jQuery);